import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import IconClose from "components/Icon/Close";
import UIHr from "components/UI/Hr";

const SimpleContainer = styled.div.attrs({ className: "aside" })`
  background: ${props => props.theme.colors.white};
  box-shadow: 0 0 30px 0 rgba(109, 120, 129, 0.06);
  height: 100%;
  overflow-y: scroll;
  width: 392px;
`;

const FloatingContainer = styled(SimpleContainer)`
  position: fixed;
  top: 0;
  left: ${props =>
    props.float === "left" ? (props.isOpen ? 0 : "-392px") : "initial"};
  right: ${props =>
    props.float === "right" ? (props.isOpen ? 0 : "-392px") : "initial"};
  transition: left 0.2s, right 0.2s;
  z-index: 5;
`;

const Header = styled.div.attrs({ className: "aside__header" })`
  display: flex;
  justify-content: space-between;
  padding: 24px 32px 23px;
`;

const Content = styled.div.attrs({ className: "aside__content" })`
  padding: 20px 32px 0;
`;

const Hr = styled(UIHr)`
  margin: 0 32px;
`;

class UIAside extends React.Component {
  state = { isOpen: true };

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen !== undefined && props.isOpen !== state.isOpen) {
      return { isOpen: props.isOpen };
    }
    return null;
  }

  handleClose = () => {
    this.setState({ isOpen: false });
    this.props.onClose && this.props.onClose();
  };

  render() {
    const { title, children, float } = this.props;

    const isOpen =
      this.props.isOpen !== undefined ? this.props.isOpen : this.state.isOpen;

    const Container = float ? FloatingContainer : SimpleContainer;
    return (
      <Container float={float} isOpen={isOpen}>
        <Header>
          <h2>{title}</h2>
          <IconClose onClick={this.handleClose} />
        </Header>

        <Hr />

        <Content>{children}</Content>
      </Container>
    );
  }
}

UIAside.propTypes = {
  title: PropTypes.string,
  float: PropTypes.oneOf(["right", "left"]),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default UIAside;
